module.exports = __webpack_public_path__ + "93f3556f0a9312c5f93436bd053b5390.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-jielun.png
// module id = 237
// module chunks = 30